// URL to Opencast Studio
export const studioURL = "/studio";

// Duration of different notification types
// sets how long an error notification is shown
export const ADMIN_NOTIFICATION_DURATION_ERROR = 5;
// sets how long a success notification is shown
export const ADMIN_NOTIFICATION_DURATION_SUCCESS = 5;
// sets how long a warning notification is shown
export const ADMIN_NOTIFICATION_DURATION_WARNING = 5;
// sets how long global notifications are shown
export const ADMIN_NOTIFICATION_DURATION_GLOBAL = 5;
